import { themeSignal, toggleTheme } from '../theme/theme';
import { Button } from './ui/Button';

/**
 * Compact icon-only button that flips dark <-> light. Placed in the AppShell
 * top bar. Emoji sun/moon are placeholders — an SVG icon set will replace
 * these once we have one.
 */
export function ThemeToggle() {
  const mode = themeSignal.value;
  const isDark = mode === 'dark';
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? '☀' : '☾'}
    </Button>
  );
}
